module.exports = __webpack_public_path__ + "media/images/pic/kid-mobile-7bf213d01bc628f1d41d33b89f654714.jpeg";